/** @format */

import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

//TRANSLATIONS ARE DEFINED IN src/components/Translate/I18n.js:18

i18n.use(XHR)
    .use(LanguageDetector)
    .init({
        interpolation: { escapeValue: false },
        defaultNS: 'login',
        fallbackLng: ['pl', 'en'],
        debug: true,
        react: {
            wait: true,
        },
        backend: {
            loadPath: '/i18n/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
